<template>
  <div>
    <slot name="default" v-if="$auth.authenticated"></slot>
    <div style="padding-top: 30px;" v-else>
       <h3 class="normal" style="margin-bottom: 1rem; text-align: center;" v-if="content">Please login to access this content:</h3>
       <h3 class="normal" style="margin-bottom: 1rem; text-align: center;" v-else>Please login to access this page:</h3>
       <br>
       <login-signup @refresh="refresh"></login-signup>
    </div>
  </div>
</template>

<script>
import { LoginSignup } from '@/components'

const props = {
  content: {
    type: Boolean,
    required: false
  }
}

const name = 'login_wrapper'

const methods = {
  refresh () {
    this.$forceUpdate()
  }
}

const components = {
  LoginSignup
}

export default {
  props,
  name,
  methods,
  components
}
</script>



// WEBPACK FOOTER //
// src/components/common/LoginWrapper.vue